<template>
  <div login>
    <transition name="fade">
      <popup v-if="login">
        <div class="panel login">
          <div class="ttl">로그인<a class="close" @click="closeLogin"></a></div>
          <div class="cont" :class="{requested: loginRequested}">
            <text-input class="crn" placeholder="사업자등록번호를 – 없이 입력해주세요." v-model="companyNo" mandatory title="사업자등록번호를 입력해주세요"/>
            <text-input type="password" class="pwd" placeholder="비밀번호를 입력해주세요." v-model="pwd" @enter="loginAction" mandatory title="비밀번호를 확인해주세요"/>
            <div class="certify">
              <div class="tab" :class="{error: contactType === ''}" title="인증수단을 선택해주세요">
                <a @click="contactType = 'e'" :class="{on: contactType === 'e'}"><span class="email">이메일 인증</span></a>
                <a @click="contactType = 's'" :class="{on: contactType === 's'}"><span class="phone">휴대폰 인증</span></a>
<!--                <a @click="notice"><span class="phone">휴대폰 인증</span></a>-->
              </div>
              <div class="cert-form" v-if="contactType">
                <text-input placeholder="휴대폰번호를 입력해주세요." :key="'input-s'" v-if="contactType === 's'" digit title="휴대폰번호를 입력해주세요" v-model="contact" mandatory/>
                <text-input placeholder="이메일 주소를 입력해주세요." :key="'input-e'" v-else email title="이메일주소를 확인해주세요" v-model="contact" mandatory/>
                <a :class="{error: !authCodeSent}" title="인증번호를 발송해주세요" @click="authCodeSend">인증번호발송</a>
                <div class="cert-num">
                  <text-input placeholder="인증번호를 입력해주세요." auth-code mandatory title="인증번호를 입력해주세요" v-model="authCode"/>
                  <span>{{ countdown }}</span>
                </div>
              </div>
              <p v-else>휴대폰 or 이메일로 발송되는 인증번호를 입력해주세요.</p>
            </div>
            <div class="error-msg"><span v-if="errorMsg"><i class="ico-warning"></i>{{ errorMsg }}</span></div>
            <a class="btn red login" @click="loginAction">로그인</a>
            <div class="save">
              <!--<label class="checkbox"><input type="checkbox"><i></i>아이디저장</label>-->
              <div class="btns">
                <a @click="openFindPwd">비밀번호찾기</a>
              </div>
            </div>
            <div class="join">계정이 필요하신가요? <a @click="goJoin">[회원가입]</a></div>
          </div>
        </div>
      </popup>
    </transition>
    <transition name="fade">
      <popup v-if="findPw">
        <div class="panel find">
          <div class="ttl">비밀번호 찾기<a class="close" @click="findPw = false"></a></div>
          <div class="cont" :class="{requested: findPwRequested}">
            <text-input class="crn" placeholder="사업자등록번호를 – 없이 입력해주세요." v-model="companyNo" mandatory title="사업자등록번호를 입력해주세요"/>
            <text-input class="email" placeholder="가입시 등록한 이메일을 입력해주세요." email title="이메일주소를 확인해주세요" v-model="email" mandatory/>
            <div class="error-msg"><span v-if="errorMsg"><i class="ico-warning"></i>{{ errorMsg }}</span></div>
            <a class="btn red confirm" @click="findPwAction">비밀번호 찾기</a>
          </div>
        </div>
      </popup>
    </transition>
    <transition name="fade">
      <popup v-if="findPwResult">
        <div class="panel find result">
          <div class="ttl">비밀번호 찾기<a class="close" @click="findPwResult = false"></a></div>
          <div class="cont">
            <div class="result">
              가입시 등록하신 이메일로 <br>
              비밀번호 재설정 URL이 발급되었습니다. <br>
              이메일을 확인해주세요.<br>
              <em class="id">{{ email }}</em><br>
            </div>
            <div class="btn-wrap"><a class="btn red wf tc" @click="findPwResult = false">확인</a></div>
          </div>
        </div>
      </popup>
    </transition>
    <transition name="fade">
      <popup v-if="requested">
        <div class="panel unapproved">
          <div class="ttl">로그인<a class="close" @click="requested = false"></a></div>
          <div class="cont">
            <div class="result">
              <em>회원가입 신청이 아직 승인되지 않았습니다.</em>
              영업일 기준 1~3일 정도 소요됩니다.
              <ul>
                <li>&middot; 신청일 &nbsp;&nbsp;&nbsp;&nbsp; : {{ requestTime | time }}</li>
                <!--<li>&middot; 문의 사항 &nbsp;: 02)xxx-xxxx</li>-->
              </ul>
            </div>
            <a class="btn red wf tc mt-30" @click="requested = false">확인</a>
          </div>
        </div>
      </popup>
    </transition>
    <transition name="fade">
      <popup v-if="rejected">
        <div class="panel refused">
          <div class="ttl">로그인<a class="close" @click="rejected = false"></a></div>
          <div class="cont">
            <div class="result">
              회원가입 신청이 반려되었습니다.
              <em>반려사유 : {{ rejectedReason }}</em>
              <ul>
                <li>&middot; 신청일 &nbsp;&nbsp;&nbsp;&nbsp; : {{ requestTime | time }}</li>
                <li>&middot; 반려일 &nbsp;&nbsp;&nbsp;&nbsp; : {{ rejectTime | time }}</li>
              </ul>
            </div>
            <p class="tel"><span>문의 사항 : 02)xxx-xxxx</span></p>
            <div class="btn-wrap">
              <a class="btn red" @click="goJoin">회원가입</a>
              <a class="btn line" @click="rejected = false">닫기</a>
            </div>
          </div>
        </div>
      </popup>
    </transition>
  </div>
</template>

<style lang="less">
@import "../../../less/proj";
[login] {
  [popup] {
    .panel { .rel; .mh-c; .w(420); .p(30, 40, 40); .-box; top: 50vh; transform: translateY(-50%); background: #fff;
      &:before { .cnt; .abs; .lt; .wh(100%, 10px); background: #464d5d; }
      &:after { .cnt; .abs; .lt; .wh(105px, 10px); background: @c-red; }
      .ttl { .rel; .fs(24); .bold; .pb(10);
        .close { .abs; .rt(0, 3px); .wh(20); .contain('@{common}/pop-close-b.png'); }
      }
      &.login {
        .cont {
          input { font-size: 13px; }
          input.crn { .wf; .pl(50); .bg('@{join}/ico-crn.png'); .no-repeat; background-position: 20px center; border-color: #c2c2c2; }
          input.pwd { .wf; .mt(10); .pl(50); .bg('@{join}/ico-pwd.png'); .no-repeat; background-position: 23px center; border-color: #c2c2c2; }
          .certify { .mt(10); .-a(#dbdcdf);
            .tab { .ib-list; .-b(#dbdcdf);
              a { .w(50%); background: #f6f7f9; .tc; .fs(15); .lh(40); color: #464d5d; .-box;
                span { .ib; .pl(24); .bg('@{join}/ico-email.png'); .bg-yc; .no-repeat; }
                &.on { color: #fff; background: #464d5d;
                  span { .bg('@{join}/ico-email-w.png'); }
                }
              }
              a + a { .-l(#e8e9ec);
                span { .pl(30); .bg('@{join}/ico-phone.png'); }
                &.on span { .bg('@{join}/ico-phone-w.png'); }
              }
            }
            > p { .fs(13); .lh(34); color: #464d5d; .tc; }
            .cert-form { .p(9); .ib-list;
              input { .h(36); .p(0, 15); }
              > input { .w(214); border-color: #c2c2c2; }
              > input + a { .ib; .ml(5); .wh(101, 36); .fs(13); .lh(36); color: #fff; background: #464d5d; .tc; .vat; }
              .cert-num { .rel; .mt(10); .wf;
                [text-input] { .wf; border-color: #c2c2c2; }
                span { .ib; .fs(13); .lh(36); .abs; .rt(17, 0); .bold; }
              }
            }
          }
          .error-msg { .tc; .p(15, 0); color: @c-red; }
          .btn.login { .wf; .tc; }
          .save { .pt(15);
            .btns { .tc; .fs(13); color: #666;
              a + a:before { content: '|'; .ib; .p(0, 10); }
            }
          }
          .join { .tc; .pt(15); .mt(30); .-t(@c-border); color: #666;
            a { color: @c-red; .bold; }
          }
        }
      }
      &.find {
        .cont {
          input { font-size: 13px; .wf; .pl(50); .no-repeat; border-color: #c2c2c2; }
          input + input { .mt(10); }
          input.id { .bg('@{join}/ico-id.png'); background-position: 20px center; }
          input.crn { .bg('@{join}/ico-crn.png'); background-position: 22px center; }
          input.email { .bg('@{join}/ico-email-g.png'); background-position: 20px center; }
          .error-msg { .tc; .p(15, 0); color: @c-red; }
          .btn.confirm { .wf; .tc; }
          .find-other { .tc; .pt(15); .mt(30); .-t(@c-border); color: #666;
            a { color: @c-red; .bold; }
          }
        }
      }
      &.find.result {
        .cont { .pt(35); .-t(@c-border);
          .result { .tc; .fs(16);
            em.id { .ib; .mt(10); .fs(24); .bold; }
            .sm { .fs(13); .mt(15); }
            .blue { .bold; color: #325b83; .mt(15); }
          }
          .btn-wrap { .mt(30); .ib-list;
            .btn { .w(168); font-size: 15px; .tc; }
            .btn + .btn { .ml(4); }
          }
        }
      }
      &.unapproved {
        .cont { .pt(35); .-t(@c-border);
          .result { .tc; .fs(13);
            em { .block; .fs(18, 1.8); .bold; }
            ul { .mt(15); background: #f6f7f9; color: #325b83; .tl; .p(15, 30); .lh(26); }
          }
        }
      }
      &.refused {
        .cont { .pt(35); .-t(@c-border);
          .result { .tc; .fs(13);
            em { .block; .fs(18, 1.8); .bold; }
            ul { .mt(15); background: #f6f7f9; color: #325b83; .tl; .p(15, 30); .lh(26); }
          }
          .tel { .m(20, 0); .fs(18); .bold; .tc;
            span { .ib; .pl(34); .bg('@{join}/ico-tel.png'); .no-repeat; .bg-yc; }
          }
          .btn-wrap { .mt(30); .ib-list;
            .btn { .w(168); font-size: 15px; .tc; }
            .btn + .btn { .ml(4); }
          }
        }
      }
    }
  }
}
</style>

<script>
import KeyVisual from '../component/KeyVisual.vue';
import BreadCrumb from '../component/BreadCrumb.vue';
import Tab from '../component/Tab.vue';
import Pagination from '../../components/Pagination.vue';
import Popup from '../../components/Popup.vue';
import TextInput from '../../components/TextInput.vue';

export default {
  components: {
    KeyVisual, BreadCrumb, Tab, Pagination, Popup, TextInput,
  },
  data() {
    return {
      contactType: '',
      findPw: false,
      findPwResult: false,
      findPwResult2: false,
      requested: false,
      rejected: false,
      errorMsg: '',
      countSecond: 0,
      companyNo: '',
      pwd: '',
      contact: '',
      authCode: '',
      email: '',
      loginRequested: false,
      authCodeSent: false,
      timerId: -1,
      authToken: '',
      findPwRequested: false,
      requestTime: '',
      rejectTime: '',
      rejectedReason: '',
      contactTest: {
        s: /01[016789]-?\d{3,4}-?\d{4}/,
        e: /^\w[-_.\w]*@\w[-_.\w]*\.[a-z]{2,}$/i,
      },
    };
  },
  watch: {
    contactType() {
      this.errorMsg = '';
      this.loginRequested = false;
      this.contact = '';
      this.authCodeSent = false;
      this.stopTimer();
    },
    login() {
      this.stopTimer();
      this.companyNo = '';
      this.pwd = '';
      this.loginRequested = false;
      this.authCodeSent = false;
      this.authToken = '';
      this.findPwRequested = false;
      this.requestTime = '';
      this.rejectTime = '';
      this.rejectedReason = '';
    },
    companyNo() {
      this.errorMsg = '';
      this.loginRequested = false;
    },
    pwd() {
      this.errorMsg = '';
      this.loginRequested = false;
    },
    contact() {
      this.errorMsg = '';
      this.loginRequested = false;
    },
    authCode() {
      this.errorMsg = '';
      this.loginRequested = false;
    },
  },
  computed: {
    login() {
      return this.$store.state.loginOpen;
    },
    countdown() {
      if (!this.authCodeSent) return '';
      const min = Math.floor(this.countSecond / 60);
      const sec = this.countSecond - (min * 60);
      return `${min}:${sec < 10 ? '0' : ''}${sec}`;
    },
  },
  methods: {
    notice() {
      window.alert('일시적으로 문자인증이 불가합니다. 이메일인증을 사용해주세요.');
    },
    closeLogin() {
      this.$store.commit('closeLogin');
    },
    goJoin() {
      this.closeLogin();
      this.rejected = false;
      this.$router.push(`/${this.site}/join`);
    },
    openFindPwd() {
      this.closeLogin();
      this.findPw = true;
    },
    setErrorMsg(msg) {
      this.errorMsg = msg;
    },
    authCodeSend() {
      if (this.contactType === 's') {
        if (!/01[016789]-?\d{3,4}-?\d{4}/.test(this.contact)) {
          this.errorMsg = '휴대폰번호를 확인해주세요';
          return;
        }
      } else if (!/^\w[-_.\w]*@\w[-_.\w]*\.[a-z]{2,5}$/i.test(this.contact)) {
        this.errorMsg = '이메일주소를 확인해주세요';
        return;
      }

      this.errorMsg = '';
      this.loginRequested = false;
      this.oax.post(`/api/${this.site}/contactAuth`, { contactType: this.contactType, contact: this.contact, purpose: 'login' })
        .then(({ data }) => {
          this.authToken = data.token;
          this.authCodeSent = true;
          this.startTimer();
        })
        .catch(this.handler((err) => {
          this.errorMsg = err.message;
          return true;
        }));
    },
    timerTick() {
      this.countSecond -= 1;
      if (this.countSecond <= 0) {
        this.authCodeSent = false;
        this.stopTimer();
      }
    },
    startTimer() {
      this.stopTimer();
      this.countSecond = 600;
      this.timerId = setInterval(this.timerTick, 1000);
    },
    stopTimer() {
      clearInterval(this.timerId);
    },
    loginAction() {
      this.loginRequested = true;
      if (!this.short && !this.oax.validation(this.$el.querySelector('.panel.login'), this.setErrorMsg)) return;
      this.oax.post(`/api/${this.site}/login`, {
        token: this.authToken, companyNo: this.companyNo.replace(/-/g, ''), pwd: this.pwd, authCode: this.authCode, contact: this.contact,
      })
        .then(() => {
          if (this.$store.state.afterLogin) {
            window.location.href = this.$store.state.afterLogin;
          } else {
            window.location.reload();
          }
        })
        .catch(this.handler((err) => {
          switch (err.code) {
            case 'REJECTED':
              this.closeLogin();
              this.requestTime = err.data.requested;
              this.rejectTime = err.data.rejected;
              this.rejectedReason = err.data.rejectedReason;
              this.rejected = true;
              break;
            case 'REQUESTED':
              this.closeLogin();
              this.requestTime = err.data.requested;
              this.requested = true;
              break;
            default:
              this.errorMsg = err.message;
          }
          return true;
        }));
    },
    findPwAction() {
      this.findPwRequested = true;
      if (!this.oax.validation(this.$el.querySelector('.panel.find'), this.setErrorMsg)) return;
      this.oax.post(`/api/${this.site}/findPwd`, { companyNo: this.companyNo, email: this.email })
        .then(() => {
          this.findPwRequested = false;
          this.findPw = false;
          this.findPwResult = true;
        })
        .catch(this.handler((err) => {
          this.errorMsg = err.message;
          return true;
        }));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/front/common/Login.vue